import { app } from '../../../../app';
import { Controller } from './company-login-report.controller';

app.component('companyLoginReport', {
    controller: Controller,
    templateUrl: require('./company-login-report.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/reports/company-login-report/company-login-report.component.js